import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { FocusableItem, TestableComponent } from 'common/interfaces';
import React, { CSSProperties, useMemo } from 'react';
//@ts-ignore
// organize-imports-disable-above
import Icon from 'common/components/Icon';
import variables from 'common/config/variables';
import { getClassName } from 'common/utils';
import { useHoverable, useRipple } from 'common/utils/hooks';
import { StyledButtonProps } from './Button.styles';
const { font_color_white } = variables;

const Title = (props: { title: string; size?: 'small' | 'medium' | 'large' }) => {
  const { title, size = 'small' } = props;
  return <span className={`button-title ${size}`}>{title}</span>;
};

export interface ButtonProps extends FocusableItem, Partial<StyledButtonProps>, TestableComponent {
  title: string;
  icon?: string | React.ReactElement;
  rightIcon?: string | React.ReactElement;
  className?: string;
}

function Button(props: ButtonProps) {
  const { ripples, showRipple } = useRipple();
  const { focused, ref, focusKey } = useFocusable({
    focusable: !props.disabled,
    onFocus: props.onFocus,
    onEnterPress: (...args) => {
      !props.disabled && props.onEnterPress && props.onEnterPress(...args);
      !props.disabled && showRipple();
    },
    focusKey: props.focusKey
  });
  const { active, onMouseEnter, onMouseLeave } = useHoverable(focused);

  const memoizedSize = useMemo(() => props.size || 'small', [props.size]);
  const styleProps = useMemo(() => {
    const { title, icon, ...rest } = props;
    return rest;
  }, [props]);

  const icon = useMemo(() => props.icon || props.rightIcon, [props.icon, props.rightIcon]);

  return (
    <div
      style={{
        color: active
          ? styleProps.focusColor || styleProps.color || variables.color_grey_10
          : styleProps.color || variables.color_grey_10,
        fontWeight: styleProps.fontWeight,
        textTransform: styleProps.textTransform as CSSProperties['textTransform'],
        borderRadius: styleProps.borderRadius,
        backgroundColor: active
          ? styleProps.focusBackgroundColor || styleProps.backgroundColor
          : styleProps.backgroundColor,
        margin: styleProps.margin,
        width: styleProps.fitContainer ? '-webkit-fill-available' : 'auto'
      }}
      className={`${getClassName('button', {
        focused: active,
        disabled: props.disabled
      })} ${memoizedSize} ${props.className || ''}`}
      ref={ref}
      key={`button-${focusKey}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={(!props.disabled && (props.onEnterPress as any)) || undefined}
      data-test-id={props.testId}
    >
      {ripples}
      {props.rightIcon && <Title title={props.title} size={memoizedSize} />}
      {icon && (
        <div className="button-icon-container" key={`button-icon-container-${focusKey}`}>
          {typeof icon === 'string' ? (
            <Icon src={icon} key={`button-icon-${focusKey}`} size="verySmall" />
          ) : (
            icon
          )}
        </div>
      )}
      {/* <span className={`button-title ${memoizedSize}`}>{props.title}</span> */}
      {!props.rightIcon && <Title title={props.title} size={memoizedSize} />}
    </div>
  );
}
export default React.memo(Button);
